var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.twMerge('animate-pulse rounded bg-gray-200', _vm.twClass)})
}
var staticRenderFns = []

export { render, staticRenderFns }